import { render, staticRenderFns } from "./LeoOrderNew.vue?vue&type=template&id=907ba254&scoped=true&"
import script from "./LeoOrderNew.vue?vue&type=script&lang=js&"
export * from "./LeoOrderNew.vue?vue&type=script&lang=js&"
import style0 from "./LeoOrderNew.vue?vue&type=style&index=0&id=907ba254&lang=less&scoped=scoped&"
import style1 from "./LeoOrderNew.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907ba254",
  null
  
)

export default component.exports